module.exports = __webpack_public_path__ + "img/Picture11.b745c590.jpg";